// ── Animation & Timing ──

export const DUAL_PERIOD_AUTO_ADVANCE_DELAY_MS = 600;
export const RADIO_AUTO_ADVANCE_DELAY_MS = 400;
export const FREQUENCY_AUTO_ADVANCE_DELAY_MS = 350;
export const CARD_TRANSITION_DURATION_MS = 220;

export interface ConsentItem {
  key: string;
  icon: string;
  title: string;
  summary: string;
  details: string;
  link?: string;
  linkLabel?: string;
  feeInfoBox?: {
    title: string;
    intro: string;
    bullets: string[];
    footer: string;
  };
}
